export default __webpack_public_path__ + "static/media/1200.d2f0fedf.JPG";